const thrpyPlanStatus = {
  Submitted: {
    id: 0,
    name: 'Submitted',
  },
  Accepted: {
    id: 1,
    name: 'Accepted',
  },
  Denied: {
    id: 2,
    name: 'Denied',
  },
  NoSubmitted: {
    id: 3,
    name: 'NoSubmitted',
  },
};

export default thrpyPlanStatus;
